

























































































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import moment from 'moment';
import ErrorAlert from '../common/ErrorAlert.vue';
import { ErrorManager } from '@/models/error';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    created_at_after: null as null | Date,
    created_at_before: null as null | Date,

    afterMenu: false,
    beforeMenu: false,

    useDateRange: false
  }),

  watch: {
    created_at_after(val) {
      if (
        this.created_at_before &&
        moment(val).isAfter(this.created_at_before, 'day')
      ) {
        this.created_at_before = null;
      }
    }
  },

  computed: {
    filterParams(): Record<string, Date> {
      const params: Record<string, Date> = {};
      if (this.useDateRange) {
        if (this.created_at_after) {
          params.created_at_after = moment(this.created_at_after)
            .startOf('day')
            .toDate();
        }
        if (this.created_at_before) {
          params.created_at_before = moment(this.created_at_before)
            .endOf('day')
            .toDate();
        }
      }
      return params;
    }
  },

  methods: {
    ...mapActions({
      exportQuoteXML: 'quote/exportQuoteXML'
    }),

    open() {
      this.created_at_after = null;
      this.created_at_before = null;
      this.dialog = true;
      this.clearAllErrors();
    },

    allowedDatesUntilToday(val: string) {
      return moment(val).isSameOrBefore(new Date(), 'day');
    },

    allowedDatesAfterStart(val: string) {
      if (!this.created_at_after) {
        return true;
      }
      return (
        moment(val).isSameOrAfter(this.created_at_after, 'day') &&
        this.allowedDatesUntilToday(val)
      );
    },

    close() {
      this.dialog = false;
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    generateXML() {
      this.clearAllErrors();
      this.loading = true;
      this.exportQuoteXML(this.filterParams)
        .then((data: Blob) => {
          this.createXml(data);
          this.close();
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createXml(data: Blob) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      const linkName = `quotes-${moment(new Date()).format(
        'YYYY-MM-DD-HH-mm-ss'
      )}.xml`;
      link.href = url;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
});
